export const initialState = {
    groupInfoData: [],
    routingLevelsData: [],
    settingId: 0,
    curationRoutingOptions: [],
    curationRoutingValueByGroup: [],
    reroutingIntervalTabValue: 'reroutingIntervalCountryDays',
    abortPeriodTabValue: 'abortPeriodCountry',
    expertsAssignedTabVal: 'expertsAssignedCountry',
    isLoading: false,
    agenticSource: null
}

const adminSettings = (state = initialState, action) => {
    switch (action.type) {
        case "groupInfoData":
            state = { ...state, groupInfoData: action.payload }
            return state;
        case "routingLevelsData":
            state = { ...state, routingLevelsData: action.payload }
            return state;
        case "toggleSettingsBox":
            state = { ...state, settingId: action.payload }
            return state;
        case "getAgenticSource":
            state = { ...state, agenticSource: action.payload }
            return state;

        case "getCurationRFoutingValuesAdmin":
            state = { ...state, curationRoutingOptions: action.payload }
            let newArr = [...action.payload];
            let optionsArr = newArr.map((obj) => {
                let obj1 = { id: obj.id, value: obj.name, label: obj.description, active: obj.active }
                return obj1;
            })
            state = { ...state, curationRoutingOptions: optionsArr }
            return state;
        case "curationValueByGroups":
            state = { ...state, curationRoutingValueByGroup: action.payload }
            let curationGroupArr = [...action.payload]
            let defaultValueCuration = curationGroupArr.map((obj, ind) => {
                let obj1 = { visibility: obj.description === 'Level' ? true : false, startPointValue: obj.startPointValue, active: obj.active, description: obj.description, id: obj.id, name: obj.name, startPointId: obj.startPointId, label: obj.description, value: obj.name }
                return obj1;
            })
            state = { ...state, curationRoutingValueByGroup: defaultValueCuration }
            return state;
        case 'updateValues':
            state = {
                ...state,
                [action.payload.key]: action.payload.value
            };
            return state;
        case "updateTabValForReroutingInterval":
            state = { ...state, reroutingIntervalTabValue: action.payload }
            return state;
        case "updateTabIndexValueAbortPeriod":
            state = { ...state, abortPeriodTabValue: action.payload }
            return state;
        case "updateTabIndexForExpertsAssigned":
            state = { ...state, expertsAssignedTabVal: action.payload }
            return state;
        case "isLoadingAdmin":
            state = { ...state, isLoading: action.payload }
            return state;
        default:
            return state;
    }
}

export default adminSettings;
